export const combineErrorStacks = (
  err: Error | unknown,
  originalErr: Error,
): Error => {
  if (err instanceof Error) {
    err.stack = `${err.stack}\nCaused by:\n${originalErr.stack
      ?.split('\n')
      .slice(2)
      .join('\n')}`;
    return err;
  }

  return originalErr;
};

export const excludeDepStack = (
  stack: string | undefined,
): string | undefined => {
  return stack
    ? stack
        .split('\n')
        .filter(
          (s, i) =>
            // The first line of stack is an error message, so it should be included.
            i === 0 ||
            ((s.includes(location.hostname) || s.includes('Caused by')) &&
              !s.includes('node_modules') &&
              !s.includes('assets/vendor')),
        )
        .join('\n')
    : undefined;
};
